enum PolicyTypes {
    Vehicle = 'vehicles',
    House = 'houses',
    Travel = 'travels'
}

export default PolicyTypes

